module.exports = __webpack_public_path__ + "img/avatar2.f07d66e0.png";